/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "481d35df386b8a6cfc16ab31de51896c2779dabf";
